import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","justify-content":"center","align-items":"center"} }

import { reactive, ref, onMounted, unref } from 'vue';
import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable'
import { useLocales } from '@/hooks/useLocales';
import { GetNationListApi, DeleteNationApi } from '../../../apis/basics/nation.api';
import { TableColumn } from '@/components/GbTables/GbTablesTypes'
import NationImportDialog from './components/importDialog.vue'
import EditNationDialog from './components/editDialog.vue'
import NationDetailDialog from './components/detailDialog.vue'

import CurrencyImportDialog from './components/importCurrencyDialog.vue'

import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const nationImportRef = ref<InstanceType<typeof NationImportDialog>>()
const editNationRef = ref<InstanceType<typeof EditNationDialog>>()
const currencyImportRef = ref<InstanceType<typeof CurrencyImportDialog>>()
const detailRef = ref<InstanceType<typeof NationDetailDialog>>()

// 获取多语言翻译函数
const { t } = useLocales();

/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<any>({
    getListApi: GetNationListApi,
    delListApi: DeleteNationApi,
    response: { data: 'data', total: 'total' }
})

const { setSearchParams } = methods

const searchDto = reactive<any>({
    page_size: 10,
    current: 1,
});

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
    { field: 'nation_code', label: t('nations.table.nationCode', '国家编号'), columnWidth: "100" },
    { field: 'nation_name_cn', label: t('nations.table.nationNameCn', '名称(中文)'), columnWidth: "200" },
    { field: 'nation_name_en', label: t('nations.table.nationNameEn', '名称(英文)'), columnWidth: "250" },
    { field: 'nation_iso_code', label: t('nations.table.isoCode', 'ISO编码'), columnWidth: "100", align: "center" },
    { field: 'continent', label: t('nations.table.continent', '所属大陆'), columnWidth: "80", align: "center" },
    { field: 'remark', label: t('nations.table.remark', '备注') },
    { field: 'sort', label: t('nations.table.sort', '排序'), columnWidth: "80", align: 'center' },
    { field: 'is_enabled', label: t('nations.table.status', '状态'), columnWidth: "80", align: "center" },
    { field: 'created_time', label: t('nations.table.createdDate', '创建日期'), columnWidth: "120", fixed: 'right', align: "center" },
    { field: 'action', width: '150px', label: t('nations.table.action', '操作'), fixed: 'right', align: 'center' },
])

const actions = {
    import: () => {
        unref(nationImportRef)?.openDialog();
    },
    importCurrency: () => {
        unref(currencyImportRef)?.openDialog();
    },
    getElTagDic: (item: any) => {
        const continentDic = new Map();
        continentDic.set("1", t('nations.form.asia', '亚洲'))
        continentDic.set("2", t('nations.form.europe', '欧洲'))
        continentDic.set("3", t('nations.form.northAmerica', '北美洲'))
        continentDic.set("4", t('nations.form.southAmerica', '南美洲'))
        continentDic.set("5", t('nations.form.africa', '非洲'))
        continentDic.set("6", t('nations.form.oceania', '大洋洲'))
        continentDic.set("7", t('nations.form.antarctica', '南极洲'))
        continentDic.set("9", t('nations.form.other', '其他'))

        return continentDic.get(`${item.continent}`) ?? "N/A";
    },
    reset: () => {
        searchDto.value = { page_size: 10, current: 1, }
        setSearchParams(searchDto)
    },
    create: () => {
        unref(editNationRef)?.showDialog({})
    },
    editor: (row: any) => {
        unref(editNationRef)?.showDialog(row)
    },
    delete: async (row: any) => {
        const deleteDto = { id: row.id, revision: row.revision }
        await methods.deleteRows(deleteDto)
    },
    preview: (row: any) => {
        unref(detailRef)?.showDialog(row);
    }
}

onMounted(() => {
    setSearchParams(searchDto)
})


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_More = _resolveComponent("More")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      shadow: "never",
      "body-style": { paddingBottom: '0' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(searchDto),
          size: "small",
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('nations.form.nationName', '国家名称')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(searchDto).name_cn,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchDto).name_cn) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('nations.form.continent', '所属大陆')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"width":"100%"},
                  modelValue: _unref(searchDto).continent,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchDto).continent) = $event)),
                  placeholder: _unref(t)('nations.form.continent', '国家所属大陆'),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_unref(setSearchParams)(_unref(searchDto))))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _unref(t)('nations.form.all', '全部'),
                      value: ""
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('nations.form.asia', '亚洲'),
                      value: "1"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('nations.form.europe', '欧洲'),
                      value: "2"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('nations.form.northAmerica', '北美洲'),
                      value: "3"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('nations.form.southAmerica', '南美洲'),
                      value: "4"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('nations.form.africa', '非洲'),
                      value: "5"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('nations.form.oceania', '大洋洲'),
                      value: "6"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('nations.form.antarctica', '南极洲'),
                      value: "7"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('nations.form.other', '其他'),
                      value: "9"
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('nations.form.status', '状态')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"width":"100%"},
                  modelValue: _unref(searchDto).is_enabled,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(searchDto).is_enabled) = $event)),
                  placeholder: _unref(t)('nations.form.currentStatus', '当前状态'),
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_unref(setSearchParams)(_unref(searchDto))))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _unref(t)('nations.form.all', '全部'),
                      value: ""
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('nations.form.enabled', '启用'),
                      value: "Y"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('nations.form.disabled', '停用'),
                      value: "N"
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      icon: "Refresh",
                      onClick: actions.reset
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('buttons.reset', '重置')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      icon: "Search",
                      type: "primary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(setSearchParams)(_unref(searchDto))))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('buttons.search', '查询')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      icon: "Flag",
                      onClick: actions.import
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('nations.buttons.importNationData', '导入国家数据')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      icon: "Money",
                      onClick: actions.importCurrency
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('nations.buttons.importCurrencyData', '导入货币数据')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      icon: "Plus",
                      type: "primary",
                      onClick: actions.create
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('nations.buttons.addNation', '新增国家/地区')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"10px"},
      disabled: _unref(tableObject).loading
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(GbTables), {
          pageSize: _unref(tableObject).pageSize,
          "onUpdate:pageSize": _cache[6] || (_cache[6] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
          currentPage: _unref(tableObject).currentPage,
          "onUpdate:currentPage": _cache[7] || (_cache[7] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
          columns: _unref(tabColumns),
          data: _unref(tableObject).tableList,
          loading: _unref(tableObject).loading,
          pagination: { total: _unref(tableObject).total },
          onRegister: _unref(register)
        }, {
          continent: _withCtx(({ row }) => [
            _createVNode(_component_el_tag, {
              type: "primary",
              size: "small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(actions.getElTagDic(row)), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          is_enabled: _withCtx(({ row }) => [
            (row.is_enabled == 'Y')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  type: "primary",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('status.enabled', '启用')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (row.is_enabled == 'N')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "danger",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('status.diabled', '停用')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          created_time: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.created_time).format('YYYY-MM-DD HH:mm')), 1)
          ]),
          action: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_button, {
                icon: "Memo",
                type: "text",
                size: "small",
                onClick: ($event: any) => (actions.preview(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('nations.buttons.detail', '详细')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_dropdown, {
                style: {"padding":"2px","margin-left":"12px"},
                size: "small",
                trigger: "click"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "text",
                            onClick: ($event: any) => (actions.editor(row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('nations.buttons.editInfo', '编辑信息')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_dropdown_item, { divided: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "danger",
                            link: "",
                            onClick: ($event: any) => (actions.delete(row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('nations.buttons.deleteRecord', '删除记录')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_More)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 1
        }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(NationImportDialog, {
      ref_key: "nationImportRef",
      ref: nationImportRef,
      onOnSaveSuccess: _cache[8] || (_cache[8] = ($event: any) => (_unref(setSearchParams)(_unref(searchDto))))
    }, null, 512),
    _createVNode(EditNationDialog, {
      ref_key: "editNationRef",
      ref: editNationRef,
      onOnSaveSuccess: _cache[9] || (_cache[9] = ($event: any) => (_unref(setSearchParams)(_unref(searchDto))))
    }, null, 512),
    _createVNode(CurrencyImportDialog, {
      ref_key: "currencyImportRef",
      ref: currencyImportRef
    }, null, 512),
    _createVNode(NationDetailDialog, {
      ref_key: "detailRef",
      ref: detailRef
    }, null, 512)
  ], 64))
}
}

})